import { useBreakpointValue } from '@genial/utils';
import React, { useMemo } from 'react';
import { FlatList } from 'react-native';

import { flatListMaxHeight } from '../constants';
import { TableItemListProps } from '../models';
import { TableItem } from '../TableItem';

import { ResponsiveLoadingFooter } from './components/LoadingFooter';
import { ResponsiveLoadingTable } from './components/LoadingTable';
import { NotFound } from './components/NotFound';

export const TableItemList: React.FC<TableItemListProps> = ({
  data,
  isLoading,
  isLoadingMore,
  hasEmpty,
  handleEndReached,
  handleClearSearch,
}) => {
  const maxHeight = useBreakpointValue({
    base: flatListMaxHeight.tablet,
    md: flatListMaxHeight.desktop,
  });

  const CustomerFlatListMemoized = useMemo(() => {
    const ListEmptyComponent = () => {
      if (!isLoading && !hasEmpty) {
        return <NotFound />;
      }

      return <ResponsiveLoadingTable />;
    };

    return (
      <FlatList
        windowSize={10}
        maxToRenderPerBatch={10}
        updateCellsBatchingPeriod={5}
        data={data}
        keyExtractor={(item) => item.accountId.toString()}
        contentContainerStyle={{ maxHeight }}
        ListEmptyComponent={ListEmptyComponent}
        showsVerticalScrollIndicator={false}
        onEndReached={handleEndReached}
        onEndReachedThreshold={1.5}
        ListFooterComponent={
          <ResponsiveLoadingFooter isLoading={isLoading} isLoadingMore={isLoadingMore} />
        }
        renderItem={({ item }) => {
          return <TableItem itemData={item} handleClearSearch={handleClearSearch} />;
        }}
      />
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, data, isLoadingMore]);

  return CustomerFlatListMemoized;
};
